import React, { Component } from 'react';
import PlaidLinkButton from "../integrations/PlaidLinkButton";
import {AccountsCollectionAdapter} from "../redux/adapters/AccountsCollectionAdapter";

class Accounts extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { cookies, isAuthenticated } = this.props;
        const csrfToken = cookies !== null && cookies !== undefined ? cookies.get('XSRF-TOKEN') : "cookies null so unavailable";
        const msgDisplay = isAuthenticated
            ?
            (
                <PlaidLinkButton csrfToken={ csrfToken }/>


            ) :
            (
                <div className="ignored ui yellow info centered message" style={{"text-align": "center"}}>
                    Sample Data! Please <b>login</b> to view your accounts
                </div>
            );

        return <>
            <div className="ui styled fluid">
                {msgDisplay}
                <div className={"ui centered card"} style={{"margin-top": "0rem", "margin-bottom": "0rem"}}>
                    <div className={"ui fluid securityModalButton"} style={{"text-align": "center", "color":"blue"}}>Manage Security </div>
                </div>

                <AccountsCollectionAdapter csrfToken={ csrfToken } />
            </div>
        </>
    }
}

export default Accounts;